import React from 'react';
import { useNavigate } from 'react-router-dom';
import PlanCards, { openContact } from '../../components/PlanCards';
import { useTenant } from '../../context/TenantContext';
import { seatLimit, seatsUsed } from '../../lib/limits';
import { formatRupees } from '../../lib/plans';
import usePlans, { usePlanLabel } from '../../lib/usePlans';
import { PageHeading, StatCards, useBasic } from './ui';
import InvoicesCard from './InvoicesCard';
import UsageCard from './UsageCard';

export default function BillingPage() {
  const { tenant, can } = useTenant();
  const { memberCount } = useBasic();
  const owner = can('billing.manage');
  const navigate = useNavigate();
  const { plans, loaded } = usePlans();
  const planLabel = usePlanLabel();
  const current = loaded ? plans.find((p) => p.code === tenant.plan) : null;
  const fixed = current?.priceType === 'fixed' && current.price;
  const monthly = fixed && memberCount != null ? formatRupees(current.price * Math.max(memberCount, current.minUsers || 1, 1)) : null;

  return (
    <section className="page-view">
      <PageHeading title="Billing & Plan" subtitle="Your subscription, and the plans available for your company." />

      <StatCards stats={[
        ['Current plan', planLabel(tenant.plan), 'Applies to the whole company'],
        ['Monthly price', fixed ? monthly : 'As agreed', fixed ? `${formatRupees(current.price)} per user · plus GST and calls` : 'Plus GST and calls'],
        ['Team members', memberCount == null ? null : seatsUsed(memberCount, tenant.max_members), 'Seats used'],
        ['Member limit', seatLimit(tenant.max_members), 'On your plan'],
      ]} />

      <UsageCard />
      {owner && <InvoicesCard />}
      {!owner && <div className="preview-banner">Only the company owner can change the plan.</div>}
      <PlanCards currentTier={tenant.plan} canChange={owner} onChoose={(p) => navigate('/payment', { state: { plan: p.code } })}
        onTalk={(p) => openContact(p, tenant.name)} />
    </section>
  );
}
